export function beoordeelWaarde(veld, waarde) {
  if (waarde === null || waarde === undefined || waarde === '') return null;
  const w = parseFloat(waarde);
  if (isNaN(w)) return null;
  const D = {
    ademfrequentie: { kl:8, l:10, h:25, kh:30 },
    o2_saturatie:   { kl:85, l:90 },
    hartslag:       { kl:40, l:50, h:100, kh:130 },
    bloeddruk_sys:  { kl:80, l:90, h:180, kh:200 },
    temperatuur:    { kl:35.0, l:36.0, h:38.5, kh:40.0 },
    bloedsuiker:    { kl:3.0, l:3.9, h:10.0, kh:15.0 },
    pijnscore:      { m:4, h:7, k:9 },
  };
  const d = D[veld];
  if (!d) return null;

  if (veld === 'o2_saturatie') {
    if (w <= d.kl) return { niveau:'kritisch', bericht:`O2-saturatie ${w}% — kritisch laag. Mogelijke respiratoire insufficiëntie.` };
    if (w <= d.l)  return { niveau:'afwijkend', bericht:`O2-saturatie ${w}% — afwijkend laag.` };
  } else if (veld === 'pijnscore') {
    if (w >= d.k)  return { niveau:'kritisch', bericht:`Pijnscore ${w}/10 — ernstige pijn.` };
    if (w >= d.h)  return { niveau:'afwijkend', bericht:`Pijnscore ${w}/10 — matige tot ernstige pijn.` };
    if (w >= d.m)  return { niveau:'afwijkend', bericht:`Pijnscore ${w}/10 — matige pijn.` };
  } else {
    if (d.kl !== undefined && w <= d.kl) return { niveau:'kritisch', bericht:`${veld.replace('_',' ')} ${w} — kritisch laag.` };
    if (d.l  !== undefined && w <= d.l)  return { niveau:'afwijkend', bericht:`${veld.replace('_',' ')} ${w} — laag.` };
    if (d.kh !== undefined && w >= d.kh) return { niveau:'kritisch', bericht:`${veld.replace('_',' ')} ${w} — kritisch hoog.` };
    if (d.h  !== undefined && w >= d.h)  return { niveau:'afwijkend', bericht:`${veld.replace('_',' ')} ${w} — verhoogd.` };
  }
  return null;
}

export function beoordeelCombinaties(invoer) {
  const w = [];
  const t = parseFloat(invoer.temperatuur), hs = parseFloat(invoer.hartslag);
  const af = parseFloat(invoer.ademfrequentie), bd = parseFloat(invoer.bloeddruk_sys);
  const o2 = parseFloat(invoer.o2_saturatie);
  let s = 0;
  if (!isNaN(t)  && (t >= 38.3 || t < 36)) s++;
  if (!isNaN(hs) && hs > 90) s++;
  if (!isNaN(af) && af > 20) s++;
  if (s >= 2) w.push({ niveau:'kritisch', code:'SEPSIS', bericht:'⚠ Combinatie suggestief voor sepsis — schakel arts in.' });
  if (!isNaN(bd) && bd < 90 && !isNaN(hs) && hs > 100) w.push({ niveau:'kritisch', code:'SHOCK', bericht:'⚠ Lage bloeddruk + hoge hartslag — mogelijke shock.' });
  if (!isNaN(o2) && o2 < 90 && !isNaN(af) && af > 25)  w.push({ niveau:'kritisch', code:'RESP', bericht:'⚠ Lage saturatie + verhoogde ademfrequentie — respiratoire insufficiëntie.' });
  return w;
}
